import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import ErrorResponse from "../../interfaces/ErrorResponse";

const base = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 120000,
});

const request = (config: AxiosRequestConfig) => {
  const onSuccess = (response: AxiosResponse) => {
    return response.data;
  };

  const onError = (error: AxiosError) => {
    let response: ErrorResponse = {
      error: "",
      message: "",
      status: error.response?.status,
      timestamp: new Date().toLocaleDateString(),
      path: "",
    };
    if (error.response && error.response.data) {
      response = error.response.data;
    }
    return Promise.reject(response);
  };
  return base(config).then(onSuccess).catch(onError);
};
export { request };
